import React from "react";
import Link from "next/link";
import styles from "./news_simple_hero.module.scss";

export const NewsSimpleHero = ({ title, subTitle, description }) => {
  return (
    <section className={styles.blog_hero_simple}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.breadcrumbs}>
            <Link legacyBehavior href="/news">
              <a>Home ›</a>
            </Link>
            <span className={styles.cat_title}>{subTitle}</span>
          </div>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.short_desc}>{description}</p>
        </div>
      </div>
    </section>
  );
};

export default NewsSimpleHero;
